import { Component, ElementRef, OnInit, Input, ViewChild, Output, AfterViewInit, EventEmitter, ViewEncapsulation, Renderer2, ChangeDetectorRef } from '@angular/core';
import { State, CompositeFilterDescriptor, filterBy, aggregateBy } from '@progress/kendo-data-query';
import { GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DispatchEquipmentAdjustmentBus } from '@app/cp/shared/models/DispatchEquipmentAdjustmentBus';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

/*******************************************************************************************************
 * Name: DispatchEquipmentAdjustmentsComponent
 * Creator: GRG
 * Date: 20210330
 * OverridesAndExtras:
 *      1) addModeOnly input - can be used so that grid does not show and only popup window shows
 *      2) dispatchId set input property - if set then windows shows and saves with that id
 *      3) after set edit - used because there is no editing of this so set readonly to show as view
 *      4) originalReadOnly - so can return readonly to original state if viewing from grid
 *      5) customCanSaveForm - if code is 'Other' then require note
 * Notes:
 * Modified:
 *******************************************************************************************************/
@Component({
    selector: 'cp-dispatch-equipment-adjustments',
    templateUrl: './dispatch-equipment-adjustments.component.html',
    styleUrls: ['./dispatch-equipment-adjustments.component.scss']
})
export class DispatchEquipmentAdjustmentsComponent extends BaseGridEditFormLinesComponent<DispatchEquipmentAdjustmentBus, null, ConstructionService> {

    costCodeCF: MSCLFilterClass;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    @Input() addModeOnly: boolean = false; //Do not show grid -
    @Input() multiAddMode: boolean = false; //Multiple Job Adjustment -
    private _dispatchId: any;
    @Input() set dispatchId(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this._parentId = id;
            this._dispatchId = id;
            this.addHandler();
        }
    }
    get dispatchId() {
        return this._dispatchId;
    }
    private _jobIds: any;
    @Input() set jobIds(ids: any[]) {
        this._jobIds = ids;
        if (this.multiAddMode && ids) {
            this.createDynamicFormFields();
        }
    }
    get jobIds() {
        return this._jobIds;
    }
    private _jobNbrs: any;
    @Input() set jobNbrs(ids: any[]) {
        this._jobNbrs = ids;
    }
    get jobNbrs() {
        return this._jobNbrs;
    }
    public multiAddHandler(): void {
        //let date: Date = DateFunctions.getDateNow();
        //this.selectedData = this.createNew(null);
        //this.selectedData.setNew(this.globals.userId, date, this.globals.companyId, this.globals.personId, this._parentId, this.locationDetail);
        //this.afterAddNewData();
        //this.setEdit(this.selectedData, null, true, false);
    }
    get noteCancelButtonText(): string {
        return this.readOnly ? "Ok" : "Cancel";
    }
    afterSetEdit() {
        this.originalReadOnly = this.readOnly;
        this.readOnly = !this.isNew;
    }
    protected closeEditor(): void {
        super.closeEditor();
        this.readOnly = this.originalReadOnly;
    }
    get dispatchCostAdjustmentCodeId(): any {
        return this.hasEditForm ? this.editForm.value.dispatchCostAdjustmentCodeId : null;
    }
    originalReadOnly: boolean;
    customCanSaveForm(): boolean {
        let canSave: boolean = true;
        if (CommonFunctions.hasGuidValue(this.dispatchCostAdjustmentCodeId) && this.dispatchCostAdjustmentCodeId === CommonValues.DispatchCostAdjustmentCode_Other) {
            canSave = CommonFunctions.hasStringValue(this.editForm.value.note);
        }
        return canSave;
    }

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: ConstructionService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "DispatchEquipmentAdjustmentBus";
        this.appCode = "JobEquipmentAdjustments";
        this.appName = "Equipment Job Recognition(s)";
        this.aggregates = [
            { field: 'amount', aggregate: 'sum' }
        ];
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchEquipmentAdjustmentId': new UntypedFormControl(),
            'dispatchEquipmentAdjustmentCodeId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'saleAmount': new UntypedFormControl(),
            'costAmount': new UntypedFormControl(),
            'note': new UntypedFormControl(),
            'recognitionDt': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl()
        });
    }
    createDynamicFormFields() {
        if (this.jobIds && this.jobIds.length > 0) {
            this.jobIds.forEach((element, index) => {
                this.editForm.addControl('subAmount-' + index, new UntypedFormControl('', Validators.required));
            });
        }
    }
    //getDynamicFormControl(index: number) {
    //    return this.editForm.get(`subAmount-${index}`);
    //}
    setForm() {
        this.editForm.patchValue({
            dispatchEquipmentAdjustmentId: this.selectedData.dispatchEquipmentAdjustmentId,
            dispatchEquipmentAdjustmentCodeId: this.selectedData.dispatchEquipmentAdjustmentCodeId,
            dispatchId: this.selectedData.dispatchId,
            personId: this.selectedData.personId,
            saleAmount: this.selectedData.saleAmount,
            costAmount: this.selectedData.costAmount,
            note: this.selectedData.note,
            recognitionDt: this.selectedData.recognitionDt,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId
        });
    }
    protected getChangedObject(dataObj: DispatchEquipmentAdjustmentBus) {
        let busObj: DispatchEquipmentAdjustmentBus = new DispatchEquipmentAdjustmentBus(dataObj);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(dataObj: DispatchEquipmentAdjustmentBus) {
        if (this.multiAddMode) {
            this.multiSave(dataObj);
        } else {
            let busObj: DispatchEquipmentAdjustmentBus = this.getChangedObject(dataObj);
            var isAdded = busObj.isAdded;
            this.svc_data.saveDispatchEquipmentAdjustment(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    if (!this.addModeOnly) {
                        this.removeLocalAdded();
                    }
                    let newDataObj: DispatchEquipmentAdjustmentBus = new DispatchEquipmentAdjustmentBus(info.primaryReturn);
                    //if (isAdded)
                    //{
                    //    this.gridData.splice(0, 0, newDataObj);
                    //    this.cd.detectChanges();
                    //}
                    //newDataObj.visibleToCustomer = data.visibleToCustomer;

                    this.saveSuccess(newDataObj);
                    if (!this.addModeOnly) {
                        this.doParentAction(this.parentId, "GETPAGEDATA", "DISPCOSTADJ");
                    }
                }
                else {
                    this.saveError(dataObj, "Error Saving");
                }
            });
        }
    }
    public multiSave(dataObj: DispatchEquipmentAdjustmentBus) {

        this.jobIds.forEach((jobId, index) => {
            //this.editForm.patchValue({
            //    dispatchId: jobId,
            //    amount: [`subAmount-${index}`],
            //});
            dataObj.dispatchId = jobId;
            //dataObj.amount = this.editForm.get([`subAmount-${index}`]).value;
            let busObj: DispatchEquipmentAdjustmentBus = this.getChangedObject(dataObj);
            var isAdded = busObj.isAdded;

            this.svc_data.saveDispatchEquipmentAdjustment(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    if (!this.addModeOnly) {
                        this.removeLocalAdded();
                    }
                    let newDataObj: DispatchEquipmentAdjustmentBus = new DispatchEquipmentAdjustmentBus(info.primaryReturn);

                    this.saveSuccess(newDataObj);
                    if (!this.addModeOnly) {
                        this.doParentAction(this.parentId, "GETPAGEDATA", "DISPCOSTADJ");
                    }
                }
                else {
                    this.saveError(dataObj, "Error Saving");
                }
            });
        });
    }

    deleteIndividual(data: DispatchEquipmentAdjustmentBus) {
        if (data.hasId) {
            //this.svc_data.deleteNote(data.dispatchNotesId).subscribe((dataObj: BaseMessageInfo) => {
            //    if (!dataObj.saveError) {
            //        let delDataObj: v_DispatchNoteBus = new v_DispatchNoteBus(data);

            //        this.deleteSuccess(delDataObj);
            //        this.removeLocal(delDataObj);
            //        this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
            //    }
            //    else {
            //        this.deleteError(data, dataObj.message);

            //    }
            //});
        }
        else {
            this.closeEditor();
        }
    }
    get canEditNote(): boolean {
        let can: boolean = true;

        //if (this.canEdit && this.selectedData) {
        //}

        return can;
    }
    processGridData() {
        this.costCodeCF = new MSCLFilterClass('dispatchEquipmentAdjustmentCode', 'dispatchEquipmentAdjustmentCode', this.gridData);
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
    }

}

